import { ModuleWithProviders, NgModule } from '@angular/core';
import { FbCoreBasicInputChecklistDateFromToTypeComponent } from './basic-input/fb-basic-input-checklist-date-from-to-type/fb-basic-input-checklist-date-from-to-type.component';
import { FbCoreBasicInputChecklistDateTypeComponent } from './basic-input/fb-basic-input-checklist-date-type/fb-basic-input-checklist-date-type.component';
import { FbCoreBasicInputChecklistInputComponent } from './basic-input/fb-basic-input-checklist-input/fb-basic-input-checklist-input.component';
import { FbCoreBasicInputChecklistLabelTypeComponent } from './basic-input/fb-basic-input-checklist-label-type/fb-basic-input-checklist-label-type.component';
import { FbCoreBasicInputChecklistRateTypeComponent } from './basic-input/fb-basic-input-checklist-rate-type/fb-basic-input-checklist-rate-type.component';
import { FbCoreBasicInputChecklistSingleSelectTypeComponent } from './basic-input/fb-basic-input-checklist-single-select-type/fb-basic-input-checklist-single-select-type.component';
import { FbCoreBasicInputChecklistTextTypeComponent } from './basic-input/fb-basic-input-checklist-text-type/fb-basic-input-checklist-text-type.component';
import { FbCoreBasicInputDateFromToComponent } from './basic-input/fb-basic-input-date-from-to/fb-basic-input-date-from-to.component';
import { FbCoreBasicInputDateInputComponent } from './basic-input/fb-basic-input-date-input/fb-basic-input-date-input.component';
import { FbCoreBasicInputDividerInputComponent } from './basic-input/fb-basic-input-divider-input/fb-basic-input-divider-input.component';
import { FbCoreBasicInputEmailInputComponent } from './basic-input/fb-basic-input-email-input/fb-basic-input-email-input.component';
import { FbCoreBasicInputMultiSelectComponent } from './basic-input/fb-basic-input-multi-select/fb-basic-input-multi-select.component';
import { FbCoreBasicInputNumberInputComponent } from './basic-input/fb-basic-input-number-input/fb-basic-input-number-input.component';
import { FbCoreBasicInputParagraphComponent } from './basic-input/fb-basic-input-paragraph/fb-basic-input-paragraph.component';
import { FbCoreBasicInputRateInputComponent } from './basic-input/fb-basic-input-rate-input/fb-basic-input-rate-input.component';
import { FbCoreBasicInputSectionInputComponent } from './basic-input/fb-basic-input-section-input/fb-basic-input-section-input.component';
import { FbCoreBasicInputSingleSelectComponent } from './basic-input/fb-basic-input-single-select/fb-basic-input-single-select.component';
import { FbCoreBasicInputTextInputComponent } from './basic-input/fb-basic-input-text-input/fb-basic-input-text-input.component';
import { FbCoreEditorBasicComponentRendererComponent } from './components/fb-editor-basic-component-renderer/fb-editor-basic-component-renderer.component';
import { FbCoreEditorComponentSectionComponent } from './components/fb-editor-component-section/fb-editor-component-section.component';
import { FbCoreEditorDividerComponent } from './components/fb-editor-divider/fb-editor-divider.component';
import { FbCoreEditorSectionToolbarComponent } from './components/fb-editor-section-toolbar/fb-editor-section-toolbar.component';
import { FbCorePreviewFooterComponent } from './components/fb-preview-footer/fb-preview-footer.component';
import { FbCorePreviewFrameComponent } from './components/fb-preview-frame/fb-preview-frame.component';
import { FbCorePreviewHeaderComponent } from './components/fb-preview-header/fb-preview-header.component';
import { FbCorePreviewComponent } from './components/fb-preview/fb-preview.component';
import { TfFbFormViewerComponent } from './components/tf-fb-form-viewer/tf-fb-form-viewer.component';
import { DynamicRendererDirective } from './directives/dynamic-renderer.directive';
import { GetSlicedArrayPipe } from './pipes/get-sliced-array.pipe';
import { IsBasicComponentTypePipe } from './pipes/is-basic-component-type.pipe';
import { IsNotEmptyOrUndefinedPipe } from './pipes/is-not-empty-or-undefined.pipe';
import { TfFormViewerComponent } from './tf-form-viewer.component';

import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzMessageModule, NzMessageServiceModule } from 'ng-zorro-antd/message';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { TfNgCoreModule } from 'tf-ng-core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ViewerService } from './services/viewer.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    TfFormViewerComponent,
    TfFbFormViewerComponent,
    FbCoreEditorComponentSectionComponent,
    FbCoreEditorSectionToolbarComponent,
    FbCoreEditorBasicComponentRendererComponent,
    FbCoreBasicInputParagraphComponent,
    FbCoreBasicInputSingleSelectComponent,
    FbCoreBasicInputTextInputComponent,
    FbCoreBasicInputEmailInputComponent,
    FbCoreBasicInputDateInputComponent,
    FbCoreBasicInputDateFromToComponent,
    FbCoreBasicInputNumberInputComponent,
    FbCoreBasicInputRateInputComponent,
    FbCoreBasicInputSectionInputComponent,
    FbCoreBasicInputMultiSelectComponent,
    FbCoreBasicInputChecklistInputComponent,
    FbCoreBasicInputChecklistTextTypeComponent,
    FbCoreBasicInputChecklistLabelTypeComponent,
    FbCoreBasicInputChecklistDateTypeComponent,
    FbCoreBasicInputChecklistDateFromToTypeComponent,
    FbCoreBasicInputChecklistRateTypeComponent,
    FbCoreBasicInputChecklistSingleSelectTypeComponent,
    FbCoreBasicInputDividerInputComponent,
    FbCoreEditorDividerComponent,
    FbCorePreviewComponent,
    FbCorePreviewFrameComponent,
    FbCorePreviewFooterComponent,
    FbCorePreviewHeaderComponent,
    IsNotEmptyOrUndefinedPipe,
    GetSlicedArrayPipe,
    DynamicRendererDirective,
    IsBasicComponentTypePipe,
  ],
  imports: [
    CommonModule,

    NzTabsModule,
    NzGridModule,
    NzButtonModule,
    NzIconModule,
    NzCardModule,
    NzTableModule,
    NzDropDownModule,
    NzFormModule,
    NzInputModule,
    NzDividerModule,
    NzUploadModule,
    NzSelectModule,
    NzMessageModule,
    NzAutocompleteModule,
    NzModalModule,
    NzSliderModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSwitchModule,
    NzSpaceModule,
    NzTypographyModule,
    NzMessageServiceModule,
    NzInputNumberModule,
    NzRateModule,
    NzTagModule,
    NzPopoverModule,
    NzCheckboxModule,
    NzRadioModule,
    
    DragDropModule,
    NzFormModule,
    HttpClientModule,
    ReactiveFormsModule,
    TfNgCoreModule,
  ],
  providers: [
  ],
  exports: [TfFormViewerComponent]
})
export class TfFormViewerModule {
  static forRoot(): ModuleWithProviders<TfFormViewerModule> {
    return {
      ngModule: TfFormViewerModule,
      providers: [
        ViewerService,
      ]
    }
  }
}
